import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { MdClose } from "react-icons/md";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "../Button";

import styles from "./SearchBar.module.scss";

export const SearchBar = ({
  searchQuery,
  setSearchQuery,
  placeHolder,
  searchValueFetch,
  listingSearch,
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchValueFetch();
    }
  };

  return listingSearch ? (
    <div className={clsx(styles.searchBarContainerParent)}>
      <input
        className={styles.input}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={handleKeyPress}
        type="text"
        placeholder={placeHolder}
        id="header-search"
        data-testid="header-search"
        autoComplete="off"
      />
      <Button
        className={clsx(styles.searchButton, styles.searchButton, "smallFont")}
        variant=""
        onClick={searchValueFetch}
      >
        <SearchIcon className={styles.icon} />
      </Button>
    </div>
  ) : (
    <div className={clsx(styles.searchBarContainer)}>
      <input
        className={styles.input}
        value={searchQuery}
        onInput={(e) => setSearchQuery(e.target.value)}
        type="text"
        id="header-search"
        data-testid="header-search"
        autoComplete="off"
      />
      {searchQuery ? (
        <MdClose
          className={clsx(styles.icon, styles.clickable, "largeFont")}
          onClick={() => setSearchQuery("")}
        />
      ) : (
        <SearchIcon className={styles.icon} />
      )}
    </div>
  );
};

SearchBar.propTypes = {
  searchQuery: PropTypes.string,
  setSearchQuery: PropTypes.func.isRequired,
  placeHolder: PropTypes.string,
  searchValueFetch: PropTypes.func,
  listingSearch: PropTypes.bool,
};
